{
  "ProductionTemplateCreateModal": {
    "includeBudgeting": "Uwzględnij budżetowanie",
    "customise": "Dostosuj",
    "newTemplate": "Nowy szablon produkcji",
    "description": "Utwórz i edytuj szablony produkcji dla Twojej firmy",
    "saveChanges": "Zapisz zmiany",
    "updateFailed": "Aktualizacja nie powiodła się",
    "defaultIcon": "Domyślna ikona",
    "defaultColor": "Domyślny kolor",
    "defaultCode": "Domyślny kod",
    "defaultTitle": "Domyślny tytuł",
    "defaultNumberOfDays": "Domyślna liczba dni",
    "defaultTags": "Domyślne tagi",
    "shotflowInstance": "Instancja Shotflow",
    "noInstance": "Nie wybrano instancji",
    "requiredField": "To pole jest wymagane",
    "workspaceSetup": "Konfiguracja przestrzeni roboczej",
    "callsheets": "Harmonogramy",
    "deleteTemplate": "Usuń szablon",
    "deleteConfirmationTitle": "Czy na pewno chcesz usunąć ten szablon produkcji?",
    "deleteConfirmationButton": "Usuń szablon",
    "newBudgetGroup": "Nowa grupa budżetowa",
    "newBudgetExpense": "Nowy koszt budżetowy",
    "createTemplate": "Utwórz szablon produkcji",
    "editTemplate": "Edytuj szablon produkcji",
    "templateName": "Nazwa szablonu",
    "namePlaceholder": "Nazwa",
    "fieldRequired": "To pole jest wymagane",
    "cancel": "Anuluj",
    "updatedSuccessfully": "Zaktualizowano pomyślnie",
    "locations": "Lokalizacje",
    "crew": "Ekipa",
    "stages": {
      "templateDetails": {
        "title": "Szczegóły szablonu",
        "desc": "Ustaw opis dla swojego szablonu"
      },
      "productionDefaults": {
        "title": "Domyślne ustawienia produkcji",
        "desc": "Ustaw domyślne dane, które będą automatycznie uzupełniane w różnych polach podczas tworzenia produkcji"
      },
      "resourceDefaults": {
        "title": "Domyślne zasoby",
        "desc": "Ustaw domyślne zasoby dla tego szablonu, umożliwiając użytkownikom rozpoczęcie pracy z predefiniowanym zestawem wymaganych zasobów."
      }
    }
  },
  "resourcingViewModeTablistLabel": "Plan, rzeczywiste i budżet",
  "resourcingPageTitlePlanned": "Plan",
  "resourcingPageTitleActuals": "Rzeczywiste",
  "productionListViewOptions": "Opcje widoku",
  "productionListShowResourcingBudgetColumn": "Budżetowanie",
  "productionListBudgetChartModeLabel": "Wykres budżetu",
  "productionListBudgetChartVsPlanned": "Rozliczone vs plan",
  "productionListBudgetChartVsBudget": "Plan i rozliczone vs budżet",
  "productionListCrewColumnLabel": "EKIPA",
  "productionListCrewBookedShort": "Obsadzone",
  "productionListCrewCellAria": "Obsadzone role: {{booked}} z {{total}}",
  "productionListCrewPercentTitle": "{{percent}}% ról obsadzonych",
  "productionListCrewCompleteTitle": "Wszystkie role obsadzone",
  "productionListCrewNoRoles": "Brak ról",
  "productionListBudgetColumnLabel": "BUDŻETOWANIE",
  "productionListBudgetPlannedShort": "Plan",
  "productionListBudgetActualShort": "Fakt.",
  "productionListBudgetCellAria": "Budżet {{target}}, plan {{planned}}, rozliczone {{reconciled}}",
  "productionListBudgetCellAriaNoReconciled": "Budżet {{target}}, plan {{planned}}, brak sumy rozliczonej",
  "productionListBudgetCellAriaVsPlanned": "Plan {{planned}}, rozliczone {{reconciled}}",
  "productionListBudgetCellAriaVsPlannedNoReconciled": "Plan {{planned}}, brak sumy rozliczonej",
  "productionListBudgetCellAriaPlannedOnly": "Plan {{planned}}, brak sumy rzeczywistej",
  "productionListBudgetNoReconciled": "brak rozliczonego",
  "productionListBudgetNoActual": "brak rzeczywistego",
  "productionListBudgetTargetMarkerTitle": "100% budżetu produkcji",
  "productionListBudgetPlanMarkerTitle": "100% kwoty planowanej",
  "productionDetailNotesTitle": "Notatki",
  "productionDetailFilesTitle": "Pliki",
  "resourcingFooterBookedBadgeAria": "Obsadzone role: {{booked}} z {{total}}",
  "resourcingFooterTotalPlanned": "Suma planowana {{amount}}",
  "resourcingFooterTotalActual": "Suma rzeczywista {{amount}}",
  "resourcingViewLoadingAria": "Ładowanie planu zasobów",
  "resourcingDragOverlayAria": "Przenoszenie elementu planu zasobów",
  "resourcingDragOverlayKindGroup": "Grupa",
  "resourcingDragOverlayKindRole": "Rola",
  "resourcingDragOverlayKindExpense": "Wydatek",
  "resourcingDragOverlayKindResourceLine": "Przypisanie",
  "resourcingDragOverlayKindExpenseLine": "Linia wydatku",
  "resourcingSlotCategoryPlaceholder": "Wybierz kategorię",
  "resourcingSlotExpensePlaceholder": "Wybierz wydatek",
  "resourcingGridColumnGroupName": "Grupa",
  "resourcingGridColumnItemName": "Pozycja",
  "resourcingGridColumnOrderAria": "Numer slotu",
  "resourcingGridColumnRate": "Stawka",
  "resourcingGridColumnQtyUnit": "Ilość / Jednostka",
  "resourcingGridColumnSubtotal": "Suma częściowa",
  "resourcingGridColumnFees": "Opłaty",
  "resourcingGridColumnExpenses": "Wydatki",
  "resourcingGridColumnTotal": "Razem",
  "resourcingItemAddResource": "Dodaj zasób",
  "resourcingItemAddExpense": "Dodaj wydatek",
  "resourcingExpenseLineEditTitle": "Edytuj wydatek",
  "resourcingExpenseLineCreateTitle": "Dodaj wydatek",
  "resourcingExpenseLineEditCategory": "Kategoria wydatku",
  "resourcingExpenseLineEditName": "Nazwa wydatku",
  "resourcingExpenseLineEditCancel": "Anuluj",
  "resourcingExpenseLineEditSave": "Zapisz zmiany",
  "resourcingExpenseLineCreateSave": "Dodaj wydatek",
  "resourcingExpenseLineEditClose": "Zamknij",
  "resourcingItemBookingDetails": "Szczegóły",
  "resourcingItemResourceLoadError": "Nie można wczytać zasobu",
  "resourcingAssignDialogSearchResources": "Szukaj zasobów",
  "resourcingAssignDialogSelectResources": "Wybierz zasoby",
  "resourcingAssignDialogSelectedCount_one": "{{count}} wybrany",
  "resourcingAssignDialogSelectedCount_few": "{{count}} wybrane",
  "resourcingAssignDialogSelectedCount_many": "{{count}} wybranych",
  "resourcingAssignDialogSelectedCount_other": "{{count}} wybranych",
  "resourcingAssignDialogUnselectAll": "Odznacz wszystkie",
  "resourcingAssignDialogNoResourcesFound": "Nie znaleziono zasobów",
  "resourcingAssignDialogLoadFailed": "Nie udało się wczytać zasobów",
  "resourcingAssignDialogDefaultRateLabel": "Domyślna stawka: {{rate}}",
  "resourcingAssignDialogNoRole": "Brak roli",
  "resourcingAssignDialogNoDefaultRate": "Brak stawki",
  "resourcingAssignDialogConflictCount_one": "{{count}} konflikt",
  "resourcingAssignDialogConflictCount_few": "{{count}} konflikty",
  "resourcingAssignDialogConflictCount_many": "{{count}} konfliktów",
  "resourcingAssignDialogConflictCount_other": "{{count}} konfliktów",
  "resourcingAssignDialogApplyPlannedEstimate": "Zastosuj planowany koszt do przypisanych zasobów",
  "resourcingAssignDialogPlannedEstimate": "Planowany koszt",
  "resourcingAssignDialogAppliedToCount_one": "Zastosowano do {{count}} zasobu",
  "resourcingAssignDialogAppliedToCount_few": "Zastosowano do {{count}} zasobów",
  "resourcingAssignDialogAppliedToCount_many": "Zastosowano do {{count}} zasobów",
  "resourcingAssignDialogAppliedToCount_other": "Zastosowano do {{count}} zasobów",
  "resourcingAssignDialogAssignedBookingsToBeCreated": "Przypisane rezerwacje do utworzenia",
  "resourcingAssignDialogNext": "Dalej",
  "resourcingAssignDialogBack": "Wstecz",
  "resourcingAssignDialogAssignResource": "Przypisz zasób",
  "resourcingAssignDialogAssignFailed": "Nie udało się przypisać. Spróbuj ponownie.",
  "resourcingAssignDialogWorkspaceUnknown": "Nieznany workspace: nie udało się odczytać produkcji, więc nikogo nie wyszukano.",
  "resourcingAssignDialogSlot": "Rola: {{name}}",
  "resourcingAssignDialogPick": "Wybierz do tej roli",
  "resourcingAssignDialogAlreadyAssigned": "Na tej produkcji",
  "resourcingAssignDialogAvailable": "Dostępni {{dates}}",
  "resourcingAssignDialogAvailableValue": "Dostępni",
  "resourcingAssignDialogAvailableSubject": "W terminie produkcji",
  "resourcingAssignDialogBookingsInDates": "Rezerwacje w terminie produkcji",
  "resourcingDetailsOpenBookingAria": "Otwórz rezerwację",
  "resourcingDocsOpenBookingInvoicesAria": "Otwórz faktury i paragony rezerwacji",
  "resourcingDocsOpenExpenseReceiptsAria": "Otwórz paragony wydatku",
  "resourcingDocsAddLabel": "Dodaj",
  "resourcingGridColumnPlannedTotal": "Planowana suma",
  "resourcingGridColumnInvoicesReceipts": "Faktury / paragony",
  "resourcingGridColumnActualsTotal": "Suma rzeczywista",
  "resourcingGridColumnVariance": "Różnica",
  "resourcingPendingExpenseLineAria": "Tworzenie linii wydatku",
  "resourcingAddExpensePickCategoryFirst": "Wybierz kategorię wydatku w tym wierszu (lub dodaj kategorie w ustawieniach), zanim dodasz linię.",
  "resourcingCreateExpenseFailed": "Nie udało się dodać linii wydatku",
  "resourcingNewExpenseVendorPlaceholder": "Nowy wydatek",
  "resourcingRowActionsColumnLabel": "Akcje",
  "resourcingRowActionsMenuLabel": "Otwórz menu akcji wiersza",
  "resourcingRowActionsDeleteRole": "Usuń rolę",
  "resourcingRowActionsDeleteExpenseSlot": "Usuń wydatek",
  "resourcingRowActionsRemoveAssignment": "Usuń zasób",
  "resourcingRowActionsDeleteExpenseLine": "Usuń linię wydatku",
  "resourcingRowActionsDuplicateRole": "Duplikuj rolę",
  "resourcingRowActionsDuplicateExpenseSlot": "Duplikuj slot wydatku",
  "resourcingRowActionsExcludeCostsFromBudget": "Wyklucz koszty z budżetu",
  "resourcingRowActionsIncludeCostsInBudget": "Uwzględnij koszty w budżecie",
  "resourcingSlotContextMenuAddResource": "Dodaj zasób",
  "resourcingSlotContextMenuAddExpense": "Dodaj wydatek",
  "resourcingRowContextSendBooking": "Wyślij aktualizację rezerwacji",
  "resourcingPageActionsMenuLabel": "Akcje",
  "resourcingPageActionsSendBookingUpdates": "Wyślij aktualizacje rezerwacji",
  "resourcingPageActionsSendBookingUpdatesNoPermission": "Nie masz uprawnień do wysyłania aktualizacji rezerwacji. Skontaktuj się z administratorem, jeśli potrzebujesz dostępu.",
  "resourcingPageActionsBatchAddToShortlist": "Dodaj zbiorczo do shortlisty",
  "sendBookingConfirmationDialog": {
    "title": "Wyślij aktualizację rezerwacji",
    "titleBulk": "Wyślij aktualizacje rezerwacji",
    "description": "Sprawdź, który szablon potwierdzenia zostanie użyty, a następnie wyślij e-mail.",
    "descriptionBulk": "Sprawdź, który szablon potwierdzenia zostanie użyty, a następnie wyślij aktualizacje do wszystkich kwalifikujących się rezerwacji na tej produkcji.",
    "scopeOrganizationTitle": "Szablon organizacji (globalny)",
    "scopeOrganizationDescription": "Ten e-mail użyje szablonu potwierdzenia organizacji (globalnego).",
    "scopeWorkspaceTitle": "Szablon workspace · {{workspace}}",
    "scopeWorkspaceFallback": "Workspace",
    "scopeWorkspaceDescription": "Ten e-mail użyje szablonu potwierdzenia tego workspace.",
    "scopeWorkspaceFallbackToGlobal": "Ten workspace nie ma nadpisania. Zostanie użyty szablon organizacji (globalny).",
    "editTemplateLink": "Edytuj szablon potwierdzenia",
    "recipientLabel": "Odbiorca",
    "recipientValue": "{{name}} · {{email}}",
    "recipientsBulkCount_one": "{{count}} odbiorca",
    "recipientsBulkCount_few": "{{count}} odbiorców",
    "recipientsBulkCount_many": "{{count}} odbiorców",
    "recipientsBulkCount_other": "{{count}} odbiorców",
    "recipientsBulkEmpty": "Brak potwierdzonych rezerwacji oczekujących na potwierdzenie na tej produkcji.",
    "recipientsBulkNoneReady": "Nie można jeszcze wysłać e-maili. Dodaj adresy e-mail dla kontaktów powyżej.",
    "recipientsMissingEmailMessage": "Brak e-maila dla tych zasobów. Zostaną pominięte.",
    "recipientProblemMissingEmail": "Brak e-maila",
    "recipientsLoadFailed": "Nie udało się wczytać odbiorców dla tej produkcji.",
    "previewPrevious": "Poprzedni podgląd odbiorcy",
    "previewNext": "Następny podgląd odbiorcy",
    "previewPosition": "{{current}} / {{total}}",
    "unknownRecipient": "Zasób",
    "noEmailInline": "Ten zasób nie ma adresu e-mail. Dodaj e-mail przed wysłaniem.",
    "templatePreviewLabel": "Podgląd e-maila",
    "templatePreviewHint": "To treść, która zostanie wysłana do kontaktu",
    "templateEmpty": "Brak skonfigurowanego szablonu potwierdzenia dla tego zakresu.",
    "templateLoadFailed": "Nie udało się wczytać szablonu potwierdzenia.",
    "cancel": "Anuluj",
    "send": "Wyślij",
    "sendSuccess": "Wysłano potwierdzenie rezerwacji",
    "sendSuccessBulk": "Wysłano aktualizacje rezerwacji",
    "sendFailed": "Nie udało się wysłać aktualizacji rezerwacji",
    "missingTemplateDescription": "Nie możesz wysłać potwierdzenia rezerwacji bez szablonu. Dodaj szablon potwierdzenia, aby kontynuować.",
    "goToTemplates": "Przejdź do szablonu potwierdzenia"
  },
  "resourcingContextMenuSectionRow": "Ten wiersz",
  "resourcingContextMenuSubmenuSlot": "Rola / wydatek · {{name}}",
  "resourcingContextMenuSubmenuSlotUnnamed": "Rola / wydatek",
  "resourcingContextMenuOtherLevels": "Inne poziomy",
  "resourcingContextMenuSubgroup": "Grupa · {{name}}",
  "resourcingGroupContextMenuAddRole": "Dodaj rolę",
  "resourcingGroupContextMenuAddExpense": "Dodaj wydatek",
  "resourcingGroupContextMenuDuplicate": "Duplikuj grupę",
  "resourcingGroupContextMenuDelete": "Usuń grupę",
  "resourcingGroupBookedAvailableCounter": "{{booked}}/{{available}}",
  "resourcingGroupNamePlaceholder": "Grupa bez nazwy",
  "resourcingAddGroup": "Dodaj grupę",
  "resourcingSyncAllSaved": "Zapisano",
  "resourcingSyncSavingWithCount": "Zapisywanie ({{count}})",
  "resourcingSyncSomeFailed": "Błąd zapisu",
  "resourcingSyncActivityHeading": "Aktywność synchronizacji",
  "resourcingSyncActivityAutoScroll": "Automatyczne przewijanie",
  "resourcingSyncActivityToggleAria": "Pokaż lub ukryj szczegóły synchronizacji",
  "resourcingSyncPauseOnline": "Wstrzymaj synchronizację online",
  "resourcingSyncResumeOnline": "Wznów synchronizację online",
  "resourcingSyncPaused": "Synchronizacja online wstrzymana",
  "resourcingSyncPausedWithCount": "{{count}} oczekuje na synchronizację",
  "resourcingSyncActivityStatus_executing": "Synchronizacja",
  "resourcingSyncActivityStatus_queued": "W kolejce",
  "resourcingSyncActivityStatus_staged": "Oczekuje",
  "resourcingSyncActivityStatus_awaiting_resume": "Czeka na wznowienie",
  "resourcingSyncActivityStatus_success": "Zapisano",
  "resourcingSyncActivityStatus_error": "Błąd",
  "resourcingAction.default": "Zmiana zapisana",
  "resourcingAction.default_pending": "Zapisz zmianę",
  "resourcingAction.updateSlotNote": "Zaktualizowano notatkę",
  "resourcingAction.updateSlotNote_pending": "Zaktualizuj notatkę",
  "resourcingAction.updateSlotIncludeInCalculationIncluded": "Uwzględniono w kalkulacji",
  "resourcingAction.updateSlotIncludeInCalculationIncluded_pending": "Uwzględnij w kalkulacji",
  "resourcingAction.updateSlotIncludeInCalculationExcluded": "Wyłączono z kalkulacji",
  "resourcingAction.updateSlotIncludeInCalculationExcluded_pending": "Wyłącz z kalkulacji",
  "resourcingAction.updateSlotCategory": "Zaktualizowano kategorię",
  "resourcingAction.updateSlotCategory_pending": "Zaktualizuj kategorię",
  "resourcingAction.reorderSlots": "Zmieniono kolejność slotów",
  "resourcingAction.reorderSlots_pending": "Zmień kolejność slotów",
  "resourcingAction.reorderGroups": "Zmieniono kolejność grup",
  "resourcingAction.reorderGroups_pending": "Zmień kolejność grup",
  "resourcingAction.createResourceSlot": "Dodano rolę",
  "resourcingAction.createResourceSlot_pending": "Dodaj rolę",
  "resourcingAction.duplicateResourceSlot": "Zduplikowano rolę",
  "resourcingAction.duplicateResourceSlot_pending": "Duplikuj rolę",
  "resourcingAction.duplicateBudgetExpense": "Zduplikowano slot wydatku",
  "resourcingAction.duplicateBudgetExpense_pending": "Duplikuj slot wydatku",
  "resourcingAction.addBudgetExpense": "Dodano wydatek",
  "resourcingAction.addBudgetExpense_pending": "Dodaj wydatek",
  "resourcingAction.createResourceAssignments": "Przypisano zasób",
  "resourcingAction.createResourceAssignments_pending": "Przypisz zasób",
  "resourcingAction.createBudgetExpenseLine": "Dodano linię wydatku",
  "resourcingAction.createBudgetExpenseLine_pending": "Dodaj linię wydatku",
  "resourcingAction.deleteResourceSlot": "Usunięto rolę",
  "resourcingAction.deleteResourceSlot_pending": "Usuń rolę",
  "resourcingAction.deleteBudgetExpense": "Usunięto wydatek",
  "resourcingAction.deleteBudgetExpense_pending": "Usuń wydatek",
  "resourcingAction.deleteExpenseLine": "Usunięto linię wydatku",
  "resourcingAction.deleteExpenseLine_pending": "Usuń linię wydatku",
  "resourcingAction.deleteResourceSlotAssignment": "Usunięto przypisanie",
  "resourcingAction.deleteResourceSlotAssignment_pending": "Usuń przypisanie",
  "resourcingAction.createProductionGroup": "Utworzono grupę",
  "resourcingAction.createProductionGroup_pending": "Utwórz grupę",
  "resourcingAction.duplicateProductionGroup": "Zduplikowano grupę",
  "resourcingAction.duplicateProductionGroup_pending": "Duplikuj grupę",
  "resourcingAction.updateProductionGroup": "Zmieniono nazwę grupy",
  "resourcingAction.updateProductionGroup_pending": "Zmień nazwę grupy",
  "resourcingAction.deleteProductionGroup": "Usunięto grupę",
  "resourcingAction.deleteProductionGroup_pending": "Usuń grupę",
  "resourcingAction.updateResourceSlotPlanRates": "Zaktualizowano stawkę i opłaty planu roli",
  "resourcingAction.updateResourceSlotPlanRates_pending": "Zaktualizuj stawkę i opłaty planu roli",
  "resourcingAction.updateAssignedResourceLineInterval": "Zaktualizowano interwał rezerwacji",
  "resourcingAction.updateAssignedResourceLineInterval_pending": "Zaktualizuj interwał rezerwacji",
  "resourcingAction.updateResourceLineQtyUnit": "Zaktualizowano ilość i jednostkę",
  "resourcingAction.updateResourceLineQtyUnit_pending": "Zaktualizuj ilość i jednostkę",
  "resourcingAction.updateResourceLineFees": "Zaktualizowano opłaty",
  "resourcingAction.updateResourceLineFees_pending": "Zaktualizuj opłaty",
  "resourcingAction.updateBookingRate": "Zaktualizowano stawkę rezerwacji",
  "resourcingAction.updateBookingRate_pending": "Zaktualizuj stawkę rezerwacji",
  "resourcingAction.updateBookingFees": "Zaktualizowano opłaty rezerwacji",
  "resourcingAction.updateBookingFees_pending": "Zaktualizuj opłaty rezerwacji",
  "resourcingAction.updateBookingRatesAndFees": "Zaktualizowano stawkę i opłaty rezerwacji",
  "resourcingAction.updateBookingRatesAndFees_pending": "Zaktualizuj stawkę i opłaty rezerwacji",
  "resourcingAction.updateBookingExpenseLines": "Zaktualizowano wydatki rezerwacji",
  "resourcingAction.updateBookingExpenseLines_pending": "Zaktualizuj wydatki rezerwacji",
  "resourcingAction.updateBookingStatus": "Zaktualizowano status rezerwacji",
  "resourcingAction.updateBookingStatus_pending": "Zaktualizuj status rezerwacji",
  "resourcingAction.updateBudgetExpensePlanRateFields": "Zaktualizowano stawkę planu wydatku",
  "resourcingAction.updateBudgetExpensePlanRateFields_pending": "Zaktualizuj stawkę planu wydatku",
  "resourcingAction.updateBudgetExpensePlanQuantity": "Zaktualizowano ilość planu wydatku",
  "resourcingAction.updateBudgetExpensePlanQuantity_pending": "Zaktualizuj ilość planu wydatku",
  "resourcingAction.updateBudgetExpensePlanRates": "Zaktualizowano plan wydatku",
  "resourcingAction.updateBudgetExpensePlanRates_pending": "Zaktualizuj plan wydatku",
  "resourcingAction.updateExpenseLineCommittedRateFields": "Zaktualizowano stawkę linii wydatku",
  "resourcingAction.updateExpenseLineCommittedRateFields_pending": "Zaktualizuj stawkę linii wydatku",
  "resourcingAction.updateExpenseLineCommittedQuantity": "Zaktualizowano ilość linii wydatku",
  "resourcingAction.updateExpenseLineCommittedQuantity_pending": "Zaktualizuj ilość linii wydatku",
  "resourcingAction.updateExpenseLineCommittedRates": "Zaktualizowano linię wydatku",
  "resourcingAction.updateExpenseLineCommittedRates_pending": "Zaktualizuj linię wydatku",
  "resourcingLeaveWhileSavingTitle": "Trwa zapisywanie zmian",
  "resourcingLeaveWhileSavingDescription": "Niektóre zmiany są nadal zapisywane na serwerze. Jeśli teraz wyjdziesz, zapisywanie będzie kontynuowane w tle.",
  "resourcingLeaveWhileSavingConfirm": "Wyjdź mimo to",
  "resourcingLeaveWhileSavingCancel": "Kontynuuj edycję",
  "resourcingLeaveWhileSavingBeforeUnload": "Zmiany są nadal zapisywane. Czy na pewno chcesz wyjść?",
  "resourcingRatesInlineTitleBooking": "Koszty rezerwacji",
  "resourcingRatesInlineTitleExpense": "Koszty wydatku",
  "resourcingRatesInlineTitleExpensePlan": "Plan wydatku",
  "resourcingRatesInlineExpensePlanHint": "Zaplanuj budżet slotu tutaj. Zatwierdzone kwoty edytuj w każdym wierszu wydatku poniżej.",
  "resourcingCostSheetLaneExpensePlan": "Plan dla tego slotu",
  "resourcingCostSheetFooterExpensePlan": "Suma planu wydatku",
  "resourcingCostSheetExpenseCommittedIntro": "Zatwierdzona stawka dla tej linii. Plan slotu jest w wierszu wydatku powyżej.",
  "resourcingRatesInlineTabEstimated": "Szacunek",
  "resourcingRatesInlineTabBooking": "Rezerwacja",
  "resourcingRatesInlineTabExpenseActual": "Zatwierdzone",
  "resourcingRatesInlineSectionRate": "Stawka",
  "resourcingRatesInlineSectionFees": "Opłaty",
  "resourcingRatesInlineSectionExpenses": "Wydatki",
  "resourcingCostSheetSectionResourceRate": "Stawka za zasób",
  "resourcingCostSheetSectionResourceEstimateRate": "Szacunkowa stawka zasobu",
  "resourcingCostSheetSectionResourceActualRate": "Rzeczywista stawka zasobu",
  "resourcingCostSheetSectionFees": "Opłaty",
  "resourcingCostSheetSectionResourceExpenses": "Wydatki zasobu",
  "resourcingRatesInlineAddExpense": "Dodaj wydatek",
  "resourcingRatesInlineEmptyBooking": "Przypisz osobę, by edytować.",
  "resourcingRatesInlineEmptyExpenseActual": "Ustaw zatwierdzoną stawkę, by edytować.",
  "resourcingRatesInlineTitleSlotEstimate": "Szacunek roli",
  "resourcingRatesInlineSlotEstimateHint": "Plan tutaj. Rezerwacja w wierszu przypisania.",
  "resourcingCostSheetBookingIntroRowContext": "Koszty rezerwacji. Plan roli powyżej.",
  "resourcingCostSheetLanePlan": "Plan",
  "resourcingCostSheetLaneBooked": "Rezerwacja",
  "resourcingCostSheetExpenseIntro": "Szacunek vs zatwierdzone.",
  "resourcingCostSheetLaneEstimate": "Szacunek",
  "resourcingCostSheetLaneCommitted": "Zatwierdzone",
  "resourcingCostSheetFooterPlan": "Suma planu",
  "resourcingCostSheetFooterBooked": "Suma rezerwacji",
  "resourcingCostSheetFooterEstimate": "Suma szacunku",
  "resourcingCostSheetFooterCommitted": "Suma zatwierdzona",
  "resourcingCostSheetCalculationResourceEstimate": "Szacunek zasobu",
  "resourcingCostSheetCalculationResourceActual": "Koszty rzeczywiste zasobu",
  "resourcingCostSheetCalculationExpenseEstimate": "Szacunek wydatku",
  "resourcingCostSheetCalculationExpenseActual": "Rzeczywisty wydatek",
  "resourcingCostSheetLaneRolePlan": "Plan dla tej roli",
  "resourcingCostSheetFooterRolePlan": "Suma planu roli",
  "resourcingCostSheetRemoveExpenseAria": "Usuń wydatek",
  "resourcingCostSheetExpenseCategory": "Kategoria",
  "resourcingCostSheetExpenseVendor": "Nazwa",
  "resourcingCostSheetExpenseColumnTotal": "Suma",
  "resourcingSlotEstimateQuantity": "Ilość",
  "resourcingSlotEstimateFeesHeading": "Opłaty",
  "resourcingSlotEstimateFeeAgency": "Opłata agencji",
  "resourcingSlotEstimateFeePayroll": "Opłata payroll",
  "resourcingSlotEstimateFeeProcessing": "Opłata processing",
  "resourcingSlotEstimateFeeAgencyAria": "Uwzględnij opłatę agencji",
  "resourcingSlotEstimateFeePayrollAria": "Uwzględnij opłatę payroll",
  "resourcingSlotEstimateFeeProcessingAria": "Uwzględnij opłatę processing",
  "resourcingCostSheetFeeColumnAgency": "Opłata agencji",
  "resourcingCostSheetFeeColumnPayroll": "Opłata payroll",
  "resourcingCostSheetFeeColumnProcessing": "Opłata processing",
  "resourcingCostSheetFeePercentInputAgency": "Procent opłaty agencji",
  "resourcingCostSheetFeePercentInputPayroll": "Procent opłaty payroll",
  "resourcingCostSheetFeePercentInputProcessing": "Procent opłaty processing",
  "resourcingBudgetFeesPopoverRateSubtotal": "Suma stawki",
  "resourcingBudgetFeesPopoverFeeTotal": "Suma opłat",
  "resourcingBudgetBookingExpensesDescriptionPlaceholder": "Opis",
  "resourcingBudgetBookingExpensesCreate": "Dodaj wydatek",
  "resourcingBudgetBookingExpensesIncompleteRow": "Uzupełnij szczegóły wydatku przed zapisaniem",
  "resourcingBudgetBookingExpensesTotal": "Suma wydatków",
  "resourcingBookingStatusSelectAria": "Wybierz status rezerwacji",
  "resourcingBookingStatusGroupBooking": "Rezerwacja",
  "resourcingBookingStatusGroupAvailability": "Dostępność",
  "productionDetailStatusSelectAria": "Wybierz status produkcji",
  "productionDetailStatusSearchPlaceholder": "Szukaj statusu…",
  "productionDetailStatusGroupUser": "Działania użytkownika",
  "productionDetailStatusGroupAutomated": "Działania automatyczne",
  "productionDetailNoteCreatedToast": "Notatka dodana",
  "productionDetailNoteCreateErrorToast": "Nie udało się dodać notatki",
  "productionDetailNoteDeletedToast": "Notatka usunięta",
  "productionDetailNoteDeleteErrorToast": "Nie udało się usunąć notatki",
  "productionDetailNoteDeleteAria": "Usuń notatkę",
  "productionDetailNotesFieldLabel": "Nowa notatka",
  "productionDetailNotesLoadError": "Nie udało się wczytać notatek.",
  "productionDetailNotesEmptyTitle": "Brak notatek",
  "productionDetailNotesEmptyDescription": "Dodaj notatki dla {{name}}.",
  "productionDetailNotesEmptyFallbackName": "tej produkcji",
  "productionDetailNotesUnknownUser": "Nieznany użytkownik",
  "productionDetailNotesPlaceholder": "Napisz notatkę…",
  "productionDetailNotesSubmit": "Dodaj notatkę",
  "productionDetailFileUploadedToast": "Plik przesłany",
  "productionDetailFileUploadErrorToast": "Przesyłanie nie powiodło się",
  "productionDetailFileReorderErrorToast": "Nie udało się zapisać nowej kolejności",
  "productionDetailFilesLoadError": "Nie udało się wczytać plików.",
  "productionDetailFilesEmptyTitle": "Brak plików",
  "productionDetailFilesEmptyDescription": "Prześlij briefingi, referencje lub umowy dla {{name}}.",
  "productionDetailFilesEmptyFallbackName": "tej produkcji",
  "productionDetailFileUntitled": "Plik bez nazwy",
  "TransferProductionDialog": {
    "title": "Przenieś do workspace",
    "description_one": "Przenieś {{name}} do innego workspace i zespołu.",
    "description_other": "Przenieś {{count}} produkcji do innego workspace i zespołu.",
    "fieldCurrentWorkspace": "Bieżący workspace",
    "fieldWorkspace": "Docelowy workspace",
    "fieldTeam": "Docelowy zespół",
    "selectWorkspace": "Wybierz workspace",
    "selectTeam": "Wybierz zespół",
    "save": "Przenieś",
    "transferFailed": "Przenoszenie nie powiodło się",
    "success_one": "Produkcja przeniesiona",
    "success_other": "Przeniesiono {{count}} produkcji"
  },
  "ProductionActions": {
    "transfer": "Przenieś do workspace"
  },
  "SlotResourcePicker": {
    "assign": "Przypisz",
    "moreWays": "Więcej sposobów przypisania",
    "assignAndConfirm": "Przypisz i potwierdź",
    "assignWithStatus": "Przypisz ze statusem",
    "assignAndEdit": "Przypisz i edytuj",
    "notApplied": "Nie zastosowano z wyszukiwania roli:",
    "availability": "Dostępność",
    "sort": "Sortowanie",
    "operators": {
      "s_with": "zaczyna się od",
      "e_with": "kończy się na",
      "match": "wszystkie z",
      "any": "dowolne z",
      "sort": "według",
      "from_date": "od",
      "to_date": "do",
      "status": "w statusach"
    },
    "assignFailed": "Nie udało się przypisać. Spróbuj ponownie.",
    "assignAndEditOneOnly": "Niedostępne dla kilku zasobów: wybierz jeden, aby edytować jego rezerwację."
  }
}
